import styles from "./Css/Template38.module.css";
import { useEffect, useState } from "react";
import ServiceEnquiryForm from "./FormComponent/ServiceEnquiryForm";
import { Link } from "react-router-dom";
import LastSectionComponent from "./SectionComponent/LastSectionComponent";
import Loader from "../../component/Loader/Loader";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { PageWrapper } from "../../SEOComponent/PageWrapper";

export const Template38 = ({ serviceResponse, slug }) => {

    const [toggle, setToggle] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
        setToggle((prev) => !prev);
        }, 3000);
        return () => clearInterval(interval);
    }, []);


    const [loading, setLoading] = useState(false);
      useEffect(() => {
        AOS.init({
        duration: 1000,
        once: false, // Animations only happen once
        });
    }, []);

    const navigate = useNavigate();
    return (
        <div>
            <PageWrapper slug={slug} type="Template">
            {loading && <Loader />}
            <main>
                <div className={styles.gdfbdfdfgdf554}>
                    <div className={styles.dfgjhfgd}>

                        <div className={`${styles.sdfghdfgdf} col-lg-6`}>
                            <h1 className="mt-0 mb-0">{serviceResponse.data?.banner_title &&
                                serviceResponse.data.banner_title}</h1>

                            <p className="mt-3 mb-5">{serviceResponse.data?.banner_description &&
                                serviceResponse.data.banner_description}</p>

                            <div className={styles.vbddds}>
                                <Link to="/contact-us" className="btn125">
                                    Contact Us
                                </Link>
                            <button className="btn126">
                                    <a href="tel:8420202891" style={{ color: "inherit", textDecoration: "none" }}>
                                    Get In Touch With Us
                                    </a>
                            </button>
                            </div>
                        </div>

                        <div className={`${styles.dbfghsdf} col-lg-6`}>
                            {serviceResponse.data?.banner_image && (
                                <img
                                    src={`${serviceResponse.image_url}/Templete_38/${serviceResponse.data.banner_image}`}
                                    alt="" style={{marginTop: '19px'}}
                                />
                            )}
                            {slug === "video-sharing-services" && (
                            <>
                            <div className={styles.imageContainer}>
                                <div className={styles.imageBox}>
                                    <img
                                    src={toggle ? "/images/Rank Higher in Local Searches (1).png" : "/images/Rank Higher in Local Searches.png"}
                                    alt="Location 1"
                                    className={styles.fadeImage}
                                    />
                                </div>
                                <div className={styles.imageBoxhbnxfgnj}>
                                    <img
                                    src={toggle ? "/images/Rank Higher in Local Searches.png" : "/images/Rank Higher in Local Searches (1).png"}
                                    alt="Location 2"
                                    className={styles.fadeImage}
                                    />
                                </div>
                            </div>
                            </>
                            )}
                        </div>
                    </div>

                </div>




                <div className={styles.fjhfdfgdfg}>
                    <div className="custom-container">
                        <div className={styles.sdfsdfsdf}>
                            <h2>{serviceResponse.data?.second_section_title &&
                                serviceResponse.data.second_section_title}</h2>
                            <div
                                className="pt-4"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        serviceResponse.data?.second_section_description &&
                                        serviceResponse.data.second_section_description,
                                }}
                            />
                        </div>
                    </div>
                </div>


                <div className={styles.dfngjhdfgdfg}>
                    <div className="custom-container">
                        <div className={styles.dfghdfgdf}>
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className={styles.cfbgjhcfdfsdevgzdfbg}>
                                        {slug === "video-sharing-services" && (
                                        <>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        </>
                                        )}
                                        {serviceResponse.data?.third_section_image && (
                                            <img
                                                src={`${serviceResponse.image_url}/Templete_38/${serviceResponse.data.third_section_image}`}
                                                alt=""
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className={styles.fgydfgdfg}>
                                        <h2>{serviceResponse.data?.third_section_title &&
                                            serviceResponse.data.third_section_title}</h2>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    serviceResponse.data?.third_section_description &&
                                                    serviceResponse.data.third_section_description,
                                            }}
                                        />
                                        <button onClick={() => navigate('/contact-us')}>
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.fjhfdfgdfg}>
                    <div className="custom-container">
                        <div className={styles.sdfsdfsdf}>
                            <h2>{serviceResponse.data?.fourth_section_title &&
                                serviceResponse.data.fourth_section_title}</h2>

                            <div className="pt-4"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        serviceResponse.data?.fourth_section_description &&
                                        serviceResponse.data.fourth_section_description,
                                }}
                            />
                        </div>

                    </div>
                </div>


                <ServiceEnquiryForm loading={setLoading} slug={slug} />

                <div className={styles.dfngjhdfgdfg}>
                    <div className="custom-container">
                        <div className={styles.dfghdfgdf}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className={styles.cfbgjhcfdf}>
                                 
                                        {serviceResponse.data?.fifth_section_image && (
                                            <img
                                                src={`${serviceResponse.image_url}/Templete_38/${serviceResponse.data.fifth_section_image}`}
                                                alt="" data-aos="fade-up-left"
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className={styles.fgydfgdfg}>
                                        <h2>{serviceResponse.data?.fifth_section_title &&
                                            serviceResponse.data.fifth_section_title}</h2>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    serviceResponse.data?.fifth_section_description &&
                                                    serviceResponse.data.fifth_section_description,
                                            }}
                                        />
                                        <button className="btn125" onClick={() => navigate('/contact-us')}>
                                            Contact Us
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LastSectionComponent />
            </main>
            </PageWrapper>
        </div>
    )
}
